module.exports = __webpack_public_path__ + "static/img/taboola-icon-detail.a696390.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/taboola-icon-detail.png
// module id = Mkx0
// module chunks = 46